import { Directive } from '@angular/core';
import { PretragaKatalogaProviderDirective } from '@app/components';
import { ParentListViewProvider } from '@app/components/pretraga-kataloga/providers/parent-list-view.provider';
import { TableListGridProviderDirective } from '@app/components/table-list-grid/directives/table-list-grid-provider.directive';
import {
  ListView,
  ListViewProviderDirective,
  ViewProviderDirective
} from '@ntap/core';
import { map, Observable } from 'rxjs';

@Directive({
  selector: '[appOdabirJedinicaProvider]',
  providers: [
    {
      provide: ListViewProviderDirective,
      useExisting: OdabirJedinicaProviderDirective
    },
    {
      provide: ViewProviderDirective,
      useExisting: OdabirJedinicaProviderDirective
    },
    {
      provide: ParentListViewProvider,
      useExisting: OdabirJedinicaProviderDirective
    },
    {
      provide: TableListGridProviderDirective,
      useExisting: OdabirJedinicaProviderDirective
    },
    {
      provide: PretragaKatalogaProviderDirective,
      useExisting: OdabirJedinicaProviderDirective
    }
  ],
  inputs: ['viewState', 'viewName']
})
export class OdabirJedinicaProviderDirective extends PretragaKatalogaProviderDirective {
  override get view$(): Observable<ListView> {
    return super.view$.pipe(
      map((view: any) => {
        view.actions = view.actions.filter(
          (a: any) =>
            a.name === 'openJedinicaGradiva' || a.name === 'multiselect'
        );
        return view;
      })
    );
  }
}
